import React from "react";

const WhyIcmSixth = () => (
    <svg width="35" height="12" viewBox="0 0 35 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M34.3479 0.50625C33.631 -0.1625 32.513 -0.11875 31.7595 0.50625L26.1453 5.125C25.4587 5.69375 24.6019 6 23.7148 6H16.5269C15.9922 6 15.5547 5.55 15.5547 5C15.5547 4.45 15.9922 4 16.5269 4H21.2844C22.2505 4 23.1498 3.31875 23.3077 2.3375C23.5083 1.0875 22.5725 0 21.3877 0H11.666C10.0255 0 8.43964 0.581249 7.16367 1.64375L4.3383 4H0.972169C0.437476 4 0 4.45 0 5V11C0 11.55 0.437476 12 0.972169 12H22.6515C23.5326 12 24.3893 11.6938 25.0819 11.125L34.2689 3.5625C35.1925 2.80625 35.2654 1.35625 34.3479 0.50625Z" fill="#283A97" />
    </svg>

)

export default WhyIcmSixth;